module.exports = __webpack_public_path__ + "static/seiko-01f3f412f188eb52a824865c11ea1555.png";